import { render, staticRenderFns } from "./OneTarget.vue?vue&type=template&id=72c5cbc7&scoped=true&"
import script from "./OneTarget.vue?vue&type=script&lang=js&"
export * from "./OneTarget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c5cbc7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72c5cbc7')) {
      api.createRecord('72c5cbc7', component.options)
    } else {
      api.reload('72c5cbc7', component.options)
    }
    module.hot.accept("./OneTarget.vue?vue&type=template&id=72c5cbc7&scoped=true&", function () {
      api.rerender('72c5cbc7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/test/mindAr/components/OneTarget.vue"
export default component.exports